<template>
  <div>
    <b-modal id="modalEditInventoryProfiles" ref="modalEditInventoryProfiles" :title="$t('Switch profile')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id > 0">
          <b-form-input type="text" disabled v-model="editItem.id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Profile name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input  type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Ports capacity')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.supp_volumes" placeholder="8,16,24" aria-describedby="inputFeedbackPorts" :state="editItem.supp_volumes.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackPorts"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Ports start with 0')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-checkbox v-model="editItem.isPortStartOffset"></b-checkbox>
        </b-form-group>
        <div>
          <b-tabs pills card content-class="mt-3">
            <b-tab :title="$t('Remote ID')" active>
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabRemoteID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabRemoteID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectType" v-model="editItem.tec_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.tec_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Offset')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.tec_id_meta.offset"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.tec_id_meta.len"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Port ID')">
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabPortID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabPortID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="portSelectType" v-model="editItem.port_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.port_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Offset')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.port_id_meta.offset"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.port_id_meta.len"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('VLAN ID')">
              <b-form-group label-align="right" :label="$t('Enable')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-checkbox v-model="editItem.isEnableTabVlanID"></b-checkbox>
              </b-form-group>
              <b-form-group  v-if="editItem.isEnableTabVlanID">
                <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="portSelectType" v-model="editItem.vlan_id_meta.type"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Disposition')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="remoteIDselectDis" v-model="editItem.vlan_id_meta.disposition"></b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Offset')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.vlan_id_meta.offset"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="editItem.vlan_id_meta.len"/>
                </b-form-group>
              </b-form-group>
            </b-tab>
          </b-tabs>
        </div>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveProfile">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.modalEditInventoryProfiles.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      remoteIDselectType: [
        { value: 1, text: 'String' },
        { value: 2, text: 'Binary' }
      ],
      remoteIDselectDis: [
        { value: 1, text: 'Option 82' },
        { value: 2, text: 'Agent circuit ID' },
        { value: 3, text: 'Agent remote ID' }
      ],
      portSelectType: [
        { value: 1, text: 'String' },
        { value: 3, text: 'Binary (LE)' },
        { value: 4, text: 'Binary (BE)' }
      ]
    }
  },
  methods: {
    saveProfile () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Profile name'), 'Error')
        return
      }
      if (!this.editItem.supp_volumes) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Ports capacity'), 'Error')
        return
      }
      if (!this.editItem.isEnableTabPortID) {
        this.editItem.port_id_meta.offset = 0
        this.editItem.port_id_meta.len = 0
        this.editItem.port_id_meta.type = 0
        this.editItem.port_id_meta.disposition = 0
      } else {
        if (!this.editItem.port_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (!this.editItem.port_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (!this.editItem.port_id_meta.offset) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        if (!this.editItem.port_id_meta.len) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
          return
        }
        this.editItem.port_id_meta.len = Number(this.editItem.port_id_meta.len)
        this.editItem.port_id_meta.offset = Number(this.editItem.port_id_meta.offset)
      }
      if (!this.editItem.isEnableTabRemoteID) {
        this.editItem.tec_id_meta.offset = 0
        this.editItem.tec_id_meta.len = 0
        this.editItem.tec_id_meta.type = 0
        this.editItem.tec_id_meta.disposition = 0
      } else {
        if (!this.editItem.tec_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (!this.editItem.tec_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (!this.editItem.tec_id_meta.offset) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        if (!this.editItem.tec_id_meta.len) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
          return
        }
        this.editItem.tec_id_meta.len = Number(this.editItem.tec_id_meta.len)
        this.editItem.tec_id_meta.offset = Number(this.editItem.tec_id_meta.offset)
      }
      if (!this.editItem.isEnableTabVlanID) {
        this.editItem.vlan_id_meta.offset = 0
        this.editItem.vlan_id_meta.len = 0
        this.editItem.vlan_id_meta.type = 0
        this.editItem.vlan_id_meta.disposition = 0
      } else {
        if (!this.editItem.vlan_id_meta.disposition) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select type'), 'Error')
          return
        }
        if (!this.editItem.vlan_id_meta.type) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select disposition'), 'Error')
          return
        }
        if (!this.editItem.vlan_id_meta.offset) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field offset'), 'Error')
          return
        }
        if (!this.editItem.vlan_id_meta.len) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the field length'), 'Error')
          return
        }
        this.editItem.vlan_id_meta.len = Number(this.editItem.vlan_id_meta.len)
        this.editItem.vlan_id_meta.offset = Number(this.editItem.vlan_id_meta.offset)
      }
      this.editItem.profile_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Inventory/UPDATE_SWITCH_TYPES', this.editItem)
        : this.$store.dispatch('Inventory/CREATE_SWITCH_TYPES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCH_TYPES')
          this.$refs.modalEditInventoryProfiles.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/inventoryProfiles/editModal.vue